import {SetStateAction, useRef} from 'react';
import Lightbox from 'yet-another-react-lightbox';
import type {ZoomRef} from 'yet-another-react-lightbox';
import {Zoom, Counter} from 'yet-another-react-lightbox/plugins';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/counter.css';
interface ImageModalInterface {
  images: string[];
  isOpen: boolean;
  setIsOpen: React.Dispatch<SetStateAction<boolean>>;
  onClose?: VoidFunction;
}

export default function ImageModal({
  images,
  isOpen,
  setIsOpen,
  onClose,
}: ImageModalInterface) {
  const zoomRef = useRef<ZoomRef>(null);

  const formattedImages = images.map((item: string) => ({
    src: item,
  }));

  return (
    <Lightbox
      on={{
        exited: () => {
          !!onClose && onClose();
        },
      }}
      plugins={[Zoom, Counter]}
      zoom={{
        ref: zoomRef,
        maxZoomPixelRatio: 2,
        zoomInMultiplier: 1,
        doubleTapDelay: 200,
        doubleClickDelay: 200,
        doubleClickMaxStops: 1,
        pinchZoomDistanceFactor: 30,
        scrollToZoom: true,
      }}
      counter={{
        separator: '/',
        container: {style: {top: 0, right: 0, bottom: 'unset'}},
      }}
      render={{
        iconZoomIn: () => null,
        iconZoomOut: () => null,
      }}
      carousel={{finite: true}}
      open={isOpen}
      close={() => setIsOpen(false)}
      slides={formattedImages}
    />
  );
}
